import { Link } from "react-router-dom";
import { Formik, Field, Form } from "formik";
import {
	MdOutlinePersonOutline,
	MdPassword,
} from "react-icons/md";
import * as Yup from "yup";
import CustomInput from "@components/input/CustomInput";
import FormRow from "@components/input/formRow/FormRow";
import LoginButton from "@components/button/LoginButton";
import forgotPass from "@assets/icons/forgot_password.svg";
import TranslatableText from "@components/translations/TranslatableText";

interface LoginValues {
	email: string;
	password: string;
}

const validationSchema = Yup.object({
	email: Yup.string().required("validations.field_required"), //.email("Invalid email address")
	password: Yup.string()
		/* .min(8, "Must be at least 8 characters") */
		.required("validations.field_required"),
});

const LoginForm = ({
	onLogin,
	errorMsg,
	isLoading,
}: {
	onLogin: (payload: LoginValues) => void;
	errorMsg: string;
	isLoading: boolean;
}) => {
	const handleSubmit = (values: LoginValues) => onLogin(values);

	return (
		<section className="login-form-container">
			<Formik
				initialValues={{
					email: "",
					password: "",
				}}
				validationSchema={validationSchema}
				onSubmit={handleSubmit}
			>
				{({ errors, touched }) => {
					return (
						<Form className="me-2 px-3">
							<FormRow
								error={
									errorMsg ? errorMsg : touched.email ? errors.email : undefined
								}
								classes="mb-1"
							>
								<Field
									label="Email"
									name="email"
									id="email"
									component={CustomInput}
									icon={MdOutlinePersonOutline}
									type="text"
								/>
							</FormRow>
							<FormRow
								error={touched.password ? errors.password : undefined}
								classes="mb-1"
							>
								<Field
									label="Password"
									name="password"
									id="password"
									component={CustomInput}
									icon={MdPassword}
									type="password"
								/>
							</FormRow>
							<div className="w-100 d-flex justify-content-between">
								<Link
									to="../reset-password"
									relative="path"
									className="forgot-password w-fit no-decoration"
								>
									<img src={forgotPass} alt="" className="pe-1" />
									<TranslatableText className="fs-11" translationKey="user.forgot_password" />
								</Link>
								<LoginButton isLoading={isLoading} />
							</div>
						</Form>
					);
				}}
			</Formik>
		</section>
	);
};

export default LoginForm;
